/* The three views of one plan — Przegląd, Kalendarz, Programowanie — drawn identically on the plan
 * screen and in the builder, which is a different route (owner, 30 September 2026: the builder of a
 * running plan carries the same switch, so the trainer moves between the three without a detour).
 *
 * Every value is a token. Heights are layout dimensions — see `stylelint.config.js`. */

.switch {
  display: inline-flex;
  flex: none;
  gap: var(--space-3px);
  padding: var(--space-3px);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--r-button);
}

.on {
  display: inline-flex;
  font-family: var(--font-body);
  cursor: default;
  height: 26px;
  align-items: center;
  padding: var(--space-0) var(--space-11px);
  border: var(--border-hairline) solid var(--border-2);
  border-radius: var(--r-control);
  background: var(--bg-chip);
  color: var(--text);
  font-size: var(--fs-micro);
  font-weight: var(--fw-extrabold);
  white-space: nowrap;
}

/* Drawn identically whether it is the inert label (no template to open) or the real link into the
 * builder — the canon has one `segOff` and the affordance is the pointer and the focus ring. */
.off {
  display: inline-flex;
  height: 26px;
  align-items: center;
  padding: var(--space-0) var(--space-11px);
  border: none;
  border-radius: var(--r-control);
  background: transparent;
  color: var(--text-3);
  font-family: var(--font-body);
  font-size: var(--fs-micro);
  font-weight: var(--fw-bold);
  white-space: nowrap;
}

button.off {
  cursor: pointer;
}

button.off:hover {
  color: var(--text);
}

.on:focus-visible,
button.off:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}
